import Table from "~/Models/Table.js";

export default {
    ...Table,
    fields: [
        {
            key:"_selected",
            label: "",
            sortable: false,
            filter:false,
            _filter: false,
        },
        {
            key: "id",
            label: "#",
            sorter: true,
            filter: false,
            _filter: false,
            fixed: true,
            active: true
        },
        {
            key: "storage_key",
            label: "Name",
            sorter: true,
            filter: false,
            _filter: false,
            fixed: true,
            active: true
        },
        {
            key: "status",
            label: "Status",
            sorter: true,
            filter: false,
            _filter: true,
            active: true
        },
        {
            key: "created_at",
            label: "Created at",
            sorter: true,
            filter: false,
            _filter: false,
            active: true
        },
        {
            key: "message",
            label: "Message",
            sorter: true,
            filter: false,
            _filter: true,
            active: true
        }

    ]
}
